import firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/analytics';

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'apa-nirvana.firebaseapp.com',
  projectId: 'apa-nirvana',
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
export default firebase;
